export const getMatchFromCandidates = (matchBase, candidates) => {
    if (candidates.length === 0) {
        return null;
    }
    const getProperty = (acc, value, key) => {
        if (matchBase[key] === value) {
            return value || undefined;
        }
        return acc[key];
    };
    return candidates.reduce((acc, cur) => ({
        firstName: getProperty(acc, cur.profile.name.firstName, 'firstName'),
        lastName: getProperty(acc, cur.profile.name.lastName, 'lastName'),
        middleName: getProperty(acc, cur.profile.name.middleName, 'middleName'),
        inn: getProperty(acc, cur.profile.inn, 'inn'),
        snils: getProperty(acc, cur.profile.snils, 'snils'),
        phone: getProperty(acc, cur.profile.phone, 'phone'),
        email: getProperty(acc, cur.profile.email, 'email'),
        birthday: getProperty(acc, cur.profile.birthday, 'birthday'),
    }), {});
};
export const employeeToMatchValue = (employee) => {
    if (!employee) {
        return null;
    }
    return {
        firstName: employee.profile.name.firstName || undefined,
        lastName: employee.profile.name.lastName || undefined,
        middleName: employee.profile.name.middleName || undefined,
        inn: employee.profile.inn || undefined,
        snils: employee.profile.snils || undefined,
        phone: employee.profile.phone || undefined,
        email: employee.profile.email || undefined,
        birthday: employee.profile.birthday || undefined,
    };
};
